export var ShopeePrimaryTheme = {
  color: {
    primary: {
      default: '#ee4d2d',
      bg: '#fef6f5',
      gradient: 'linear-gradient(#ee4d2d,#ff7337)'
    },
    secondary: {
      blue: '#0046ab',
      yellow: '#eda500',
      green: '#26aa99'
    },
    error: {
      default: '#ee2c4a',
      bg: '#fff4f4'
    },
    caution: {
      default: '#f69113',
      bg: '#fff8e4'
    },
    success: {
      default: '#30b566',
      bg: '#f7fffe'
    },
    text: {
      primary: {
        default: 'rgba(0,0,0,.87)',
        opaque: '#212121'
      },
      secondary: {
        default: 'rgba(0,0,0,.65)',
        opaque: '#595959'
      },
      tertiary: {
        default: 'rgba(0,0,0,.54)',
        opaque: '#757575'
      },
      link: '#0088ff'
    },
    util: {
      mask: 'rgba(0,0,0,.4)',
      disabled: {
        default: 'rgba(0,0,0,.26)',
        opaque: '#bdbdbd'
      },
      line: {
        default: 'rgba(0,0,0,.09)',
        opaque: '#e8e8e8'
      },
      bg: '#f5f5f5',
      placeholder: '#fafafa',
      pressed: 'rgba(0,0,0,.05)'
    }
  },
  typography: {
    font: {
      regular: {
        face: "-apple-system,'HelveticaNeue','Helvetica Neue','Roboto','Droid Sans',Arial,sans-serif",
        weight: '400'
      },
      medium: {
        face: "-apple-system,'HelveticaNeue-Medium','Helvetica Neue','Roboto','Droid Sans',Arial,sans-serif",
        weight: '500'
      },
      bold: {
        face: "-apple-system,'HelveticaNeue-Bold','Helvetica Neue','Roboto','Droid Sans','Arial Bold',Arial,sans-serif",
        weight: '700'
      }
    },
    size: {
      foot: {
        default: '.625rem',
        latin: {
          default: '.75rem',
          paragraph: '.75rem'
        },
        tall: {
          default: '1rem',
          paragraph: '1rem'
        }
      },
      small: {
        default: '.75rem',
        latin: {
          default: '.875rem',
          paragraph: '1.25rem'
        },
        tall: {
          default: '1.125rem',
          paragraph: '1.125rem'
        }
      },
      normal: {
        default: '.875rem',
        latin: {
          default: '1rem',
          paragraph: '1.25rem'
        },
        tall: {
          default: '1.375rem',
          paragraph: '1.375rem'
        }
      },
      large: {
        default: '1rem',
        latin: {
          default: '1.25rem',
          paragraph: '1.375rem'
        },
        tall: {
          default: '1.5rem',
          paragraph: '1.5rem'
        }
      },
      title: {
        default: '1.25rem',
        latin: {
          default: '1.5rem',
          paragraph: '1.5rem'
        },
        tall: {
          default: '1.875rem',
          paragraph: '1.875rem'
        }
      }
    }
  },
  spacing: {
    a: '.25rem',
    b: '.5rem',
    c: '.75rem',
    d: '1rem',
    e: '1.25rem',
    f: '1.5rem',
    g: '2.5rem'
  },
  elevation: {
    depth6: '0 0 .375rem rgba(0,0,0,.06)',
    depth9: '0 0 .5625rem rgba(0,0,0,.12)'
  },
  radius: {
    normal: '.125rem',
    overlay: '.25rem'
  }
};
export var ShopeeMallTheme = mergeTheme(ShopeePrimaryTheme, {
  color: {
    primary: {
      default: '#d0011b',
      bg: '#fdf2f4',
      gradient: 'linear-gradient(#d0011b,#eb5642)'
    }
  }
});
export var ShopeeMartTheme = mergeTheme(ShopeePrimaryTheme, {
  color: {
    primary: {
      default: '#066bc8',
      bg: '#f2f9ff',
      gradient: 'linear-gradient(#066bc8,#53a0e7)'
    }
  }
});
export function mergeTheme(originalTheme, overrideTheme) {
  function isString(x) {
    return typeof x === 'string';
  }
  function deepMerge(source, dest) {
    if (!source || isString(source) || !dest || isString(dest)) return;
    Object.keys(source).forEach(function (key) {
      var sourceValue = source[key];
      var destValue = dest[key];
      if (isString(sourceValue)) {
        if (isString(destValue)) {
          dest[key] = sourceValue;
        } else if (destValue && destValue.default) {
          destValue.default = sourceValue;
        } else {
          deepMerge(sourceValue, destValue);
        }
      } else {
        deepMerge(sourceValue, destValue);
      }
    });
  }
  var newTheme = JSON.parse(JSON.stringify(originalTheme));
  deepMerge(overrideTheme, newTheme);
  return newTheme;
}